const list = {
  environmentCreated: 'environment_created',
  environmentReadyForAnalisys: 'environment_ready_for_analysis',
  finalMigrationInProgress: 'final_migration_in_progress',
  migrationCompleted: 'migration_completed',
  analysisRefused: 'analysis_refused'
};

module.exports = list;
